import type { CommerceOrder, CommerceOrderItem } from "@teqtank/commerce-contracts";
import { CommerceError } from "../errors/commerce-error.js";

export function resolveCommerceOrder(value: CommerceOrder): CommerceOrder {
    if (
        !value ||
        typeof value.id !== "string" ||
        typeof value.orderNumber !== "string" ||
        !Array.isArray(value.items)
    ) {
        throw new CommerceError(
            "order-response-invalid",
            "Commerce Gateway returned an invalid Order response.",
        );
    }
    return Object.freeze({
        ...value,
        items: Object.freeze(value.items.map((item) => resolveOrderItem(item))),
        shipments: Object.freeze([...value.shipments]),
        updatedAt: new Date(value.updatedAt),
        createdAt: new Date(value.createdAt),
        ...(value.completedAt === null ? {} : { completedAt: new Date(value.completedAt) }),
    });
}

function resolveOrderItem(item: CommerceOrderItem): CommerceOrderItem {
    const value = item as CommerceOrderItem & { readonly displaySku?: string | null };
    const { displaySku, ...orderItem } = value;
    return Object.freeze({
        ...orderItem,
        ...(typeof displaySku === "string" && displaySku.trim().length > 0 ? { displaySku } : {}),
    });
}
